import React from "react";
import Navigation from "../ReuseComponent/Navigation";
import EvenLatest from "./EvenLatest";

const EventHome = () => {
  return (
    <div>
      <Navigation></Navigation>
      <EvenLatest></EvenLatest>
    </div>
  );
};

export default EventHome;
